// src/components/About.jsx
import React from 'react';
import { PRIMARY_FONT } from '../constants';
import ScribbleText from './ScribbleText';

const About = () => {
  return (
    <div className="max-w-lg mx-auto text-white notebook-card p-8 relative">
      <div className="coffee-stain" style={{ top: '-30px', right: '-25px', opacity: 0.4 }} />
      <div className="smudge" style={{ top: '60px', left: '10px' }} />

      <h2
        className="font-handwritten text-4xl font-bold mb-1 tracking-tight"
        style={{ fontFamily: PRIMARY_FONT }}
      >
        About <ScribbleText>me</ScribbleText> Ricky Zafiro
      </h2>
      <p className="font-handwritten text-xs text-white text-opacity-20 mb-6" style={{ transform: 'rotate(-1deg)' }}>
        (tercera vez que reescribo esto)
      </p>

      <div className="space-y-5 font-handwritten text-xl text-white text-opacity-70 leading-relaxed">
        <p>
          I'm Ricky Zafiro, a YouTuber, beatmaker, jazz lover, graphic designer, gamer, and I make filters for TikTok. Someday we're going to leave this world, so why not do what we love? Alongside my solo work, I'm part of{' '}
          <a href="https://manifiesto.rickyzafiro.com" target="_blank" rel="noopener noreferrer" className="text-sky-300 rough-underline">
            Manifiesto Sonidero
          </a>
          , where we bring a fresh vibe to cumbia and grupera music. I write and produce my songs from my home studio, and I'm diving into the world of piano as well.
        </p>

        <h3 className="font-bold text-white text-opacity-90 text-xl" style={{ fontFamily: PRIMARY_FONT }}>
          Biography
        </h3>

        <p>
          I was born in Xalapa, Veracruz, and I became interested in music when my dad used to leave his Yamaha PSR keyboard at home. I would secretly use it to explore the special effects and rhythms.
        </p>

        <p>
          In middle school, along with a group of friends, we dedicated ourselves to making hip-hop. Back then, I was in charge of making beats on FL Studio for my rapper friends from the neighborhood, who spoke about things happening on the streets where we lived, and where some people gathered at parties called "cotos" to listen to the songs. I also made{' '}
          <ScribbleText>ruido</ScribbleText> some music myself, but my true passion was the beats.
        </p>

        <p>
          Later, as a teenager, I joined a Catholic church choir, where I finally got to learn some <ScribbleText>acordes</ScribbleText> real music. That's where I first learned to play the piano. I wasn't playing at a high level, but it was enough to be part of a choir with a rock style. I served the church choir for seven years, which taught me a lot about music and how to convey emotions to people.
        </p>

        <p>
          I was also part of a Latin rock band called "The Chatos," where we played ska music, some Caifanes, Maná, and others, and by then, music had become everything for me.
        </p>

        <p>
          During a crucial stage of my life, an old friend encouraged me to sing karaoke, and I discovered a side of myself that I didn't know. It allowed me to open up little by little. I was surprised by how people enjoyed my singing and even cheered for me. Not many know this, but that's where I learned to sing.
        </p>

        <p>
          Due to my attention deficit, it's hard for me to focus on a single project, and I can't give 100% of my time to just one. Each new emotion that comes up motivates me to create new projects, like Manifiesto Sonidero, where my main purpose is to create tropical music in honor of my grandfather Rogelio and my dad, who passed on their love for the music of our roots, the music of Veracruz, the cumbia. I hope to complete that project as well, and thank you for reading.
        </p>

        <p>
          By the way, the name Ricky Zafiro comes from my grandmother's name, "Ricarda," whose masculine form in English is Ricky. I chose 'Zafiro' because I used to have an alter ego named{' '}
          <ScribbleText>Charles Diamond</ScribbleText>{' '}
          — but I wanted something beyond a diamond. While talking with ChatGPT, I discovered that the sapphire is better than the diamond, and, besides, it was the gem I enjoyed searching for the most in Zelda BOTW.
        </p>

        <p className="text-white text-opacity-25 text-sm text-right" style={{ transform: 'rotate(0.5deg)' }}>
          * fin de la bio. agregar más cosas despues...
        </p>
      </div>
    </div>
  );
};

export default About;
